module.exports = __webpack_public_path__ + "images/icons/flags/ES-d8cd8129.svg";